import { createFileRoute } from "@tanstack/react-router";
import { DesignSystemLayout } from "@/layout/design-system/DesignSystemLayout";

export const Route = createFileRoute("/demo/design-system")({
  component: DesignSystemLayout,
});
